import { render, staticRenderFns } from "./mdc-headline3.vue?vue&type=template&id=43a0e95c&"
import script from "./mdc-headline3.vue?vue&type=script&lang=ts&"
export * from "./mdc-headline3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports